import React from "react";
import { AppRouterLimited } from "../../../shared/components/AppRouter";
import { tasksRoutes } from "./routes";

export const TasksRoutes = () => <AppRouterLimited routes={tasksRoutes} />;
